__turbopack_context__.v({
  "trendCards": "_UEKEW_trendCards",
});
